import React, { useContext, useEffect, useState } from "react";
import { pausasHibirdo } from '../../../../utils/pausas'
import { useModal } from "../../../../hooks/ModalContext";
import { FaPause } from "react-icons/fa6";
import { DiscadorContext } from "../../../DiscadorExpert";

export const SelectBreakExpert = () => {
  const { getInfoPausa, setModal } = useModal()
  const [pausa, setPausa] = useState<string>()
  const { isLogged } = useContext(DiscadorContext)

  useEffect(() => {
    const infoPausa = pausasHibirdo.find(item => pausa === item.id)
    if (infoPausa) {
      getInfoPausa({ id: Number(infoPausa.id), descricao: infoPausa.descricao, name: '', minutes: 1, color: '' })
    }
  }, [pausa])

  function openModal() {
    if (isLogged) {
      setModal('Pausas Hibrido', 'Pausas Hibrido', false, false)
      return
    }
    setModal('O operador precisa estar logado para usar essa função', 'Error', false, true)
  }

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-2 text-sm">
        <strong className="text-primary font-normal">Pausas: </strong>
        <select
          className="w-full rounded-sm bg-gray-200 p-2 text-xs text-gray-600 outline-none"
          value={pausa}
          onChange={(e) => setPausa(e.target.value)}
        >
          {
            pausasHibirdo.map(pausa => (
              <option key={pausa.id} value={pausa.id}>{pausa?.descricao}</option>
            ))
          }
        </select>
      </div>
      <div>
        <button className="flex items-center gap-2 text-white bg-primary rounded-sm p-2  text-sm  disabled:bg-red-200 disabled:hover:bg-red-200" onClick={() => openModal()}>
          <FaPause className="fill-white" />
        </button>
      </div>
    </div>
  )
}